'use memo';

import React from 'react';
import { AgxAnimatedToggleLoader, AgxSpacer } from '@urbanx/agx.ui-components2';
import './PropertySearchLoading.scss';

export const PropertySearchLoading: React.FC = () => {
  return (
    <AgxSpacer
      className="propertySearchLoaderContent"
      contentAlignment="center"
      contentJustification="center"
      fill
    >
      <AgxAnimatedToggleLoader className="propertySearchToggleLoader" label="Loading property" />
    </AgxSpacer>
  );
};
